interface PlaceholderPageProps {
  title: string;
}

export function PlaceholderPage({ title }: PlaceholderPageProps) {
  return (
    <div className="space-y-2">
      <h2 className="font-outfit text-2xl font-semibold text-dawn-black">{title}</h2>
      <p className="font-outfit text-sm text-grey-500">This page is a placeholder.</p>
    </div>
  );
}
